import React from 'react';
import { CustomDialog } from 'components/dialog/CustomDialog';
import { HELPDESK } from 'resources/links';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const HelpdeskDialog: React.FC<IProps> = ({ open, onClose }) => (
  <CustomDialog open={open} handleClose={onClose} title="Helpdesk" maxWidth="sm" className="psf-legal-dialog">
    <div className="psf-legal-dialog__body">
      <p>Bei Fragen oder Problemen mit PS-Sparen erreichen Sie uns unter:</p>

      <h5>Kontakt</h5>
      <p>
        Telefon: {HELPDESK.PHONE}
        <br />
        E-Mail: <a href={`mailto:${HELPDESK.EMAIL}`}>{HELPDESK.EMAIL}</a>
      </p>
    </div>
  </CustomDialog>
);
